import { render, staticRenderFns } from "./AddNotificationType.vue?vue&type=template&id=24369e01&"
import script from "./AddNotificationType.vue?vue&type=script&lang=js&"
export * from "./AddNotificationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports